import React from "react";
import Slide1 from "../../images/home/pic1.jpg";
import Slide2 from "../../images/home/pic4.jpg";
import Slide3 from "../../images/home/pic3.jpg";
import Fadeup from "../fadeup/Fadeup";
import { FaArrowDown } from "react-icons/fa";
import { Link } from "react-router-dom";

const slides = [ Slide3, Slide1, Slide2,];

function OutNow() {
  return (
    <section className="mt-5">
      <div className="sec_pd">
      <Fadeup delay={0.3}>
      <h3 className="text-start  mx-3  pb-2 text-black fs_40">
       Out Now: The Art Basel and Anachronistic Auction House Art<br /> Market Report 2025 by Arts Economics
        </h3>
        </Fadeup>
        <Fadeup delay={0.2}>
        <p className="text-start sub_para   mb-4 mx-3  pb-2 text-black">The ninth edition co-published by Art Basel and UBS, provides a comprehensive, macroeconomic, benchmark analysis of the global art market in 2024.<br /> It examines its various segments, including galleries and dealers, auction houses, and art fairs, assessing their performance against the backdrop of changes in the global economic and wealth context.</p>
        </Fadeup>
        <Link
            to="/news"
            className="btn btn-golden-glass text-white position-relative overflow-hidden border-0"
        >
          <div
            className=" d-flex  justify-content-center align-items-center"
            
            >
            <p className="m-0  text-white fw-bold button_name" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              Read More 
             
            </p>
          </div>
        </Link>
        
    
      </div>
    </section>
    
  );
  
}

export default OutNow;
